/* ═══════════════════════════════════════════
   ALpha Cases — theme.js v2.1
   ═══════════════════════════════════════════ */

'use strict';

/* ── CONFIG (set from Liquid in theme.liquid) ── */
const Boldacc = window.BOLDACC || { prepaidDiscount: 10000, partialCodAdvance: 100 };

/* ── CART STATE ── */
let cartData = { items: [], item_count: 0, total_price: 0 };

/* ═══════════════════
   NAVIGATION
═══════════════════ */
function toggleNav(id) {
  const allItems = document.querySelectorAll('.nav-item');
  allItems.forEach(el => {
    if (el.dataset.nav !== id) {
      el.classList.remove('is-open');
      const trigger = el.querySelector('.nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  });
  const item = document.querySelector('[data-nav="' + id + '"]');
  if (!item) return;
  const isOpen = item.classList.toggle('is-open');
  const trigger = item.querySelector('.nav-item__trigger');
  if (trigger) trigger.setAttribute('aria-expanded', isOpen.toString());
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.nav-item')) {
    document.querySelectorAll('.nav-item.is-open').forEach(el => {
      el.classList.remove('is-open');
      const trigger = el.querySelector('.nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.nav-item.is-open').forEach(el => el.classList.remove('is-open'));
    closeMobileNav();
    closeCart();
    const searchOverlay = document.getElementById('searchOverlay');
    if (searchOverlay) searchOverlay.classList.remove('is-open');
  }
});
// Hover dropdown with close-delay (prevents premature close on diagonal mouse move)
document.querySelectorAll('.site-header__nav .nav-item').forEach(function(item) {
  var closeTimer;
  var dropdown = item.querySelector('.nav-dropdown');
  if (!dropdown) return;

  item.addEventListener('mouseenter', function() {
    clearTimeout(closeTimer);
    if (window.innerWidth > 900) {
      item.classList.add('is-open');
    }
  });

  item.addEventListener('mouseleave', function() {
    closeTimer = setTimeout(function() {
      item.classList.remove('is-open');
    }, 400); // 400ms grace period
  });
});

/* ═══════════════════
   MOBILE NAV
═══════════════════ */
function openMobileNav() {
  const drawer = document.getElementById('mobileNavDrawer');
  const overlay = document.getElementById('mobileNavOverlay');
  const btn = document.getElementById('hamburgerBtn');
  if (drawer) drawer.classList.add('is-open');
  if (overlay) { overlay.style.display = 'block'; setTimeout(() => overlay.classList.add('is-open'), 20); }
  if (btn) { btn.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
  document.body.style.overflow = 'hidden';
}

function closeMobileNav() {
  const drawer = document.getElementById('mobileNavDrawer');
  const overlay = document.getElementById('mobileNavOverlay');
  const btn = document.getElementById('hamburgerBtn');
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) { overlay.classList.remove('is-open'); setTimeout(() => { overlay.style.display = 'none'; }, 320); }
  if (btn) { btn.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
  document.body.style.overflow = '';
}

function toggleMobileAccordion(trigger) {
  const body = trigger.nextElementSibling;
  const isOpen = trigger.classList.toggle('is-open');
  if (body) body.classList.toggle('is-open', isOpen);
  trigger.setAttribute('aria-expanded', isOpen.toString());
}

/* ═══════════════════
   SWIPE CLOSE MOBILE NAV
═══════════════════ */
(function() {
  let startX = 0;
  document.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  document.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - startX;
    const drawer = document.getElementById('mobileNavDrawer');
    if (drawer && drawer.classList.contains('is-open') && dx < -60) closeMobileNav();
  }, { passive: true });
})();

/* ═══════════════════
   CART
═══════════════════ */
async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;
    cartData = await res.json();
    updateCartUI();
  } catch(e) {}
}

function updateCartUI() {
  const count = cartData.item_count || 0;
  const countEl = document.getElementById('cartCount');
  if (countEl) {
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'flex' : 'none';
  }

  const cartItems   = document.getElementById('cartItems');
  const cartEmpty   = document.getElementById('cartEmpty');
  const cartFooter  = document.getElementById('cartFooter');
  const cartSubtotal = document.getElementById('cartSubtotal');

  if (!cartItems) return;

  if (count === 0) {
    if (cartEmpty)  cartEmpty.style.display  = 'flex';
    if (cartFooter) cartFooter.style.display = 'none';
    cartItems.innerHTML = '';
    return;
  }

  if (cartEmpty)  cartEmpty.style.display  = 'none';
  if (cartFooter) cartFooter.style.display = 'block';

  if (cartSubtotal) {
    cartSubtotal.textContent = '₹' + (cartData.total_price / 100).toLocaleString('en-IN');
  }

  cartItems.innerHTML = cartData.items.map(item => `
    <div class="cart-item" data-variant-id="${item.variant_id}">
      <a href="${item.url}" class="cart-item__image-link">
        <img src="${item.image || ''}" alt="${item.title}" class="cart-item__image" width="80" height="80" loading="lazy">
      </a>
      <div class="cart-item__details">
        <div class="cart-item__title"><a href="${item.url}">${item.product_title}</a></div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
        <div class="cart-item__price">₹${(item.final_line_price / 100).toLocaleString('en-IN')}</div>
        <div class="cart-item__qty-row">
          <div class="cart-item__qty">
            <button class="qty-btn" onclick="updateCartItem(${item.variant_id}, ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span class="qty-display">${item.quantity}</span>
            <button class="qty-btn" onclick="updateCartItem(${item.variant_id}, ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
          <button class="cart-item__remove" onclick="updateCartItem(${item.variant_id}, 0)">Remove</button>
        </div>
      </div>
    </div>
  `).join('');
}

async function addToCart(variantId, quantity, properties) {
  try {
    const body = { items: [{ id: variantId, quantity: quantity || 1, properties: properties || {} }] };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      showToast(err.description || 'Could not add to cart. Please try again.', true);
      return;
    }
    await fetchCart();
    openCart();
    showToast('Added to cart!');
  } catch(e) {
    showToast('Error adding to cart. Please try again.', true);
  }
}

async function updateCartItem(variantId, quantity) {
  try {
    const updates = {};
    updates[variantId] = quantity;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    await fetchCart();
    // If on cart page, reload so Liquid totals refresh
    if (document.querySelector('.cart-page')) window.location.reload();
  } catch(e) {}
}

function openCart() {
  const drawer  = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (drawer)  drawer.classList.add('is-open');
  if (overlay) { overlay.style.display = 'block'; setTimeout(() => overlay.classList.add('is-open'), 20); }
  document.body.style.overflow = 'hidden';
  fetchCart();
}

function closeCart() {
  const drawer  = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (drawer)  drawer.classList.remove('is-open');
  if (overlay) { overlay.classList.remove('is-open'); setTimeout(() => { overlay.style.display = 'none'; }, 320); }
  document.body.style.overflow = '';
}

/* ═══════════════════
   QUICK ADD
═══════════════════ */
function quickAddToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  addToCart(variantId, 1);
}

/* ═══════════════════
   PRODUCT PAGE
═══════════════════ */
function setMainImage(thumb) {
  const mainImg = document.getElementById('mainImage');
  if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
  document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
  thumb.classList.add('is-active');
}

function thumbsSlide(dir) {
  const track = document.getElementById('galleryThumbs');
  if (!track) return;
  const thumb = track.querySelector('.product-gallery__thumb');
  const step = thumb ? (thumb.offsetWidth + 8) * 2 : 160;
  track.scrollBy({ left: dir * step, behavior: 'smooth' });
}

// Option selectors
let selectedOptions = {};

function selectOption(btn, position) {
  const container = btn.closest('.option-pills, .color-swatches');
  if (!container) return;
  container.querySelectorAll('.option-pill, .color-swatch').forEach(el => el.classList.remove('is-active'));
  btn.classList.add('is-active');
  const selectedLabel = document.getElementById('opt-selected-' + position);
  if (selectedLabel) selectedLabel.textContent = btn.dataset.value;
  selectedOptions[position] = btn.dataset.value;
  updateVariantFromOptions();
}

function selectOptionFromDropdown(select, position) {
  const value = select.value;
  const selectedLabel = document.getElementById('opt-selected-' + position);
  if (selectedLabel) selectedLabel.textContent = value;
  selectedOptions[position] = value;
  updateVariantFromOptions();
}

function updateVariantFromOptions() {
  if (!window.productVariants || !window.productVariants.length) return;

  const optionValues = Object.keys(selectedOptions)
  .sort((a,b)=>a-b)
  .map(k => selectedOptions[k]);
  const matchingVariant = window.productVariants.find(variant =>
    optionValues.every((val, i) => variant.options[i] === val)
  );

  if (!matchingVariant) return;

  const variantInput = document.getElementById('variantId');
  if (variantInput) variantInput.value = matchingVariant.id;

  // Update URL without reload
  if (window.history && window.history.replaceState) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', matchingVariant.id);
    window.history.replaceState({}, '', url.toString());
  }

  // Update price display
  updatePaymentPrices(matchingVariant.price, matchingVariant.compare_at_price);
  updateAddToCartButton(matchingVariant);

  // Update main image if variant has one
  if (matchingVariant.featured_image) {
    const mainImg = document.getElementById('mainImage');
    if (mainImg) mainImg.src = matchingVariant.featured_image.src;
  }

  const addBtn  = document.getElementById('addToCartBtn');
  const btnText = document.getElementById('addToCartText');
  const buyNowWrap = document.querySelector('.product-buynow-wrap');

  if (addBtn) {
    addBtn.disabled = !matchingVariant.available;
    if (!matchingVariant.available && btnText) btnText.textContent = 'Sold Out';
  }
  if (buyNowWrap) buyNowWrap.style.display = matchingVariant.available ? 'block' : 'none';
}

function updatePaymentPrices(price, comparePrice) {
  const fmt = v => '₹' + (Math.max(0, v) / 100).toLocaleString('en-IN');
  const discount = Boldacc.prepaidDiscount;

  const prepaidFinal    = document.getElementById('prepaidFinalPrice');
  const prepaidOriginal = document.getElementById('prepaidOriginalPrice');
  if (prepaidFinal)    prepaidFinal.textContent    = fmt(price - discount);
  if (prepaidOriginal) prepaidOriginal.textContent = fmt(price);

  const partialFinal = document.getElementById('partialFinalPrice');
  if (partialFinal)  partialFinal.textContent = fmt(price);

  const codFinal = document.getElementById('codFinalPrice');
  if (codFinal)  codFinal.textContent = fmt(price);

  /* UI Improvement – Update Main Product Price on variant change */
  const mainPriceWrap = document.querySelector('.product-main-price');
  if (mainPriceWrap) {
    const priceCurrent = mainPriceWrap.querySelector('.price-current');
    const priceOriginal = mainPriceWrap.querySelector('.price-original');
    const discountBadge = mainPriceWrap.querySelector('.price-discount-badge');
    if (priceCurrent) priceCurrent.textContent = fmt(price);
    if (comparePrice && comparePrice > price) {
      if (priceOriginal) { priceOriginal.textContent = fmt(comparePrice); priceOriginal.style.display = ''; }
      if (discountBadge) { discountBadge.textContent = '-' + Math.round((comparePrice - price) * 100 / comparePrice) + '%'; discountBadge.style.display = ''; }
    } else {
      if (priceOriginal) priceOriginal.style.display = 'none';
      if (discountBadge) discountBadge.style.display = 'none';
    }
  }
}

function updateAddToCartButton(variant) {
  const btn     = document.getElementById('addToCartBtn');
  const btnText = document.getElementById('addToCartText');
  if (!btn || !btnText || !variant) return;
  if (!variant.available) { btnText.textContent = 'Sold Out'; return; }
  const discount = Boldacc.prepaidDiscount;
  const formatted = '₹' + (Math.max(0, variant.price - discount) / 100).toLocaleString('en-IN');
  btnText.textContent = 'Add to Cart';
}

function updateBuyNowUrl(variantId) {
  const buyNowBtn = document.getElementById('buyNowBtn');
  if (buyNowBtn) buyNowBtn.href = '/checkout?variant=' + variantId + '&quantity=1';
}

// Quantity
function changeQty(delta) {
  const input = document.getElementById('productQty');
  if (!input) return;
  input.value = Math.max(1, (parseInt(input.value) || 1) + delta);
}

// Accordion
function toggleAccordion(trigger) {
  const body = trigger.nextElementSibling;
  const isOpen = trigger.classList.toggle('is-open');
  if (body) body.classList.toggle('is-open', isOpen);
}

/* ═══════════════════
   PRODUCT FORM SUBMIT
═══════════════════ */
document.addEventListener('DOMContentLoaded', function() {

  // Load product variants JSON from embedded <script> tag
  const productJsonScripts = document.querySelectorAll('script[id^="ProductJSON-"]');
  productJsonScripts.forEach(function(script) {
    try { window.productVariants = JSON.parse(script.textContent); } catch(e) {}
  });

  // Initialize selected options from active pills/swatches
  document.querySelectorAll('.option-pills .option-pill.is-active, .color-swatches .color-swatch.is-active').forEach(el => {
    const container = el.closest('[data-option-position]');
    if (container) selectedOptions[parseInt(container.dataset.optionPosition)] = el.dataset.value;
  });

  // Initialize add to cart button text with first available variant
  if (window.productVariants && window.productVariants.length) {
    const variantInput = document.getElementById('variantId');
    const initId = variantInput ? parseInt(variantInput.value) : null;
    const initVariant = initId
      ? window.productVariants.find(v => v.id === initId)
      : window.productVariants.find(v => v.available) || window.productVariants[0];
    if (initVariant) updateAddToCartButton(initVariant);
  }

  // Product form submit → AJAX add to cart
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();

      const variantId  = parseInt(document.getElementById('variantId').value);
      const qty        = parseInt(document.getElementById('productQty')?.value || 1);
      const paymentType = document.getElementById('paymentTypeInput')?.value || 'prepaid';

      const btn     = document.getElementById('addToCartBtn');
      const btnText = document.getElementById('addToCartText');
      if (btn) { btn.disabled = true; if (btnText) btnText.textContent = 'Adding...'; }

      await addToCart(variantId, qty, { 'Payment Method': paymentType });

      if (btn) {
        btn.disabled = false;
        const v = window.productVariants && window.productVariants.find(v => v.id === variantId);
        if (v) updateAddToCartButton(v);
      }
    });
  }

  // Scroll thumbnails on swipe (mobile)
  const thumbs = document.getElementById('galleryThumbs');
  if (thumbs) {
    let startX = 0;
    thumbs.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    thumbs.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) thumbs.scrollLeft -= dx;
    }, { passive: true });
  }

  // Announcement bar animated close
  const annClose = document.querySelector('.announcement-bar__close');
  if (annClose) {
    annClose.addEventListener('click', () => {
      const bar = annClose.closest('.announcement-bar');
      if (!bar) return;
      bar.style.cssText += ';height:' + bar.offsetHeight + 'px;overflow:hidden;transition:height .3s,padding .3s';
      setTimeout(() => { bar.style.height = '0'; bar.style.padding = '0'; }, 10);
      setTimeout(() => { bar.style.display = 'none'; }, 320);
    });
  }

  // Half-star visual rendering
  document.querySelectorAll('.star--half').forEach(function(star) {
    star.style.background = 'linear-gradient(90deg, #B8963E 50%, #D9D9D9 50%)';
    star.style.webkitBackgroundClip = 'text';
    star.style.webkitTextFillColor = 'transparent';
    star.style.backgroundClip = 'text';
  });

  // Initialize cart count on every page
  fetchCart();
});

/* ═══════════════════
   TOAST
═══════════════════ */
let toastTimeout;
function showToast(message, isError) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = message;
  toast.style.background = isError ? '#C0392B' : '#1A1714';
  toast.classList.add('is-visible');
  clearTimeout(toastTimeout);
  toastTimeout = setTimeout(() => toast.classList.remove('is-visible'), 3000);
}

/* ═══════════════════
   FILTERS (collection page)
═══════════════════ */
function toggleFilters() {
  const sidebar = document.getElementById('collectionSidebar');
  const layout  = document.getElementById('collectionLayout');
  const btn     = document.getElementById('filterToggleBtn');
  if (!sidebar) return;
  const isOpen = sidebar.classList.toggle('is-open');
  if (layout) layout.classList.toggle('filters-open', isOpen);
  if (btn) { btn.classList.toggle('is-active', isOpen); btn.setAttribute('aria-expanded', isOpen.toString()); }
}

function toggleFilterGroup(btn) {
  btn.classList.toggle('is-open');
  btn.nextElementSibling.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', btn.classList.contains('is-open').toString());
}

function applyFilter() {
  const url = new URL(window.location.href);
  // Clear existing filter params
  for (const key of [...url.searchParams.keys()]) {
    if (key.startsWith('filter.')) url.searchParams.delete(key);
  }
  document.querySelectorAll('.filter-checkbox__input:checked').forEach(input => {
    url.searchParams.append(input.name, input.value);
  });
  window.location.href = url.toString();
}

function applyPriceFilter() {
  const minInput = document.querySelector('.price-range-input[name*="gte"]');
  const maxInput = document.querySelector('.price-range-input[name*="lte"]');
  if (!minInput || !maxInput) return;
  const url = new URL(window.location.href);
  if (minInput.value) url.searchParams.set(minInput.name, parseFloat(minInput.value) * 100);
  else url.searchParams.delete(minInput.name);
  if (maxInput.value) url.searchParams.set(maxInput.name, parseFloat(maxInput.value) * 100);
  else url.searchParams.delete(maxInput.name);
  window.location.href = url.toString();
}

function clearFilters() {
  window.location.href = window.location.pathname;
}

function sortCollection(value) {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', value);
  window.location.href = url.toString();
}

function setGridView(cols, btn) {
  document.querySelectorAll('.view-toggle__btn').forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');
  const grid = document.getElementById('productsGrid');
  if (grid) { grid.classList.remove('products-grid--2', 'products-grid--4'); grid.classList.add('products-grid--' + cols); }
}

/* ═══════════════════
   FILTER DRAWER (mobile)
═══════════════════ */
function openFilterDrawer() {
  const d = document.getElementById('filterDrawer');
  const o = document.getElementById('filterOverlay');
  if (d) { d.style.display = 'block'; setTimeout(() => d.classList.add('is-open'), 20); }
  if (o) { o.style.display = 'block'; setTimeout(() => o.classList.add('is-open'), 20); }
  document.body.style.overflow = 'hidden';
}
function closeFilterDrawer() {
  const d = document.getElementById('filterDrawer');
  const o = document.getElementById('filterOverlay');
  if (d) { d.classList.remove('is-open'); setTimeout(() => { d.style.display = 'none'; }, 320); }
  if (o) { o.classList.remove('is-open'); setTimeout(() => { o.style.display = 'none'; }, 320); }
  document.body.style.overflow = '';
}

/* ═══════════════════
   HOW IT WORKS TABS
═══════════════════ */
function hiwSwitch(btn, id) {
  document.querySelectorAll('.hiw-tab').forEach(t => t.classList.remove('hiw-tab--active'));
  btn.classList.add('hiw-tab--active');
  const prepaid = document.getElementById('hiw-prepaid');
  const partial = document.getElementById('hiw-partial');
  if (id === 'hiw-prepaid') { if (prepaid) prepaid.style.display = 'flex'; if (partial) partial.style.display = 'none'; }
  else                      { if (prepaid) prepaid.style.display = 'none';  if (partial) partial.style.display = 'flex'; }
}

/* ═══════════════════
   OFFER STEPS SLIDER
═══════════════════ */
function offerStepsSlide(dir) {
  var track = document.getElementById('offerStepsTrack');
  if (!track) return;
  var step = track.querySelector('.offer-step');
  var stepWidth = step ? (step.offsetWidth + 8) : 120;
  track.scrollBy({ left: dir * stepWidth, behavior: 'smooth' });
}

function toggleMobileSubAccordion(trigger) {
  const body = trigger.nextElementSibling;
  const isOpen = trigger.getAttribute('aria-expanded') === 'true';

  // is level ke andar dusre open sub-accordions band karo (optional: single-open behaviour)
  const parentBody = trigger.closest('.mobile-nav__accordion-body');
  if (parentBody) {
    parentBody.querySelectorAll('.mobile-nav__sub-accordion-trigger').forEach(function(btn){
      if (btn !== trigger) {
        btn.setAttribute('aria-expanded', 'false');
        btn.nextElementSibling.style.maxHeight = null;
        btn.classList.remove('is-open');
      }
    });
  }

  trigger.setAttribute('aria-expanded', String(!isOpen));
  trigger.classList.toggle('is-open', !isOpen);

  if (!isOpen) {
    body.style.maxHeight = body.scrollHeight + 'px';
  } else {
    body.style.maxHeight = null;
  }
}